import { makeRequest } from '@orientaction/utils';
import config from './config';

const url = config.api_url;

interface FrontendErrorPayload {
  message: string;
  stack?: string;
  componentStack?: string;
  route: string;
  timestamp: string;
  userId?: string;
  userAgent: string;
}
interface ApiErrorContext {
  apiUrl?: string;
  method?: string;
  status?: number;
  response?: any;
  isAxiosError?: any;
  userId?: string;
}

export const logError = async (error: Error, extra?: ApiErrorContext) => {
  // only for production
  if (process.env.REACT_APP_API_ENDPOINT !== 'https://backend.e-orientaction.com') return;

  const payload: FrontendErrorPayload = {
    message: error.message,
    stack: error.stack,
    route: window.location.pathname,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    ...extra,
  };

  try {
    await makeRequest(
      `${url}/frontend-error/frontend-errors`,
      'POST',
      { ...payload },
      {
        'Content-Type': 'application/json',
      }
    );
  } catch {
    // silence
  }
};
